export const SET_BOOKING = 'booking/SET_BOOKING'
export const SET_INITIALISE = 'SET_INITIALISE'
export const SET_IS_LOADING = 'SET_IS_LOADING'
